module.exports = __webpack_public_path__ + "static/team-img1-03a9c8e689b2ba533473850105e6a826.jpg";